<script>
import bem from '@/utils/bem';
import { mapActions, mapState } from 'vuex';
import {
  LeftOutlined,
  RightOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
} from '@ant-design/icons-vue';
import ArtCollection from '@/components/modals/Art-collection.vue';

const b = bem('frame-template-collections');

export default {
  components: {
    RightOutlined,
    LeftOutlined,
    PlusOutlined,
    DeleteOutlined,
    EditOutlined,
    ArtCollection,
  },
  data() {
    return {
      show: false,
      isNew: false,
      selectedMaterial: {},
    };
  },
  props: {
    selectedCollection: Object,
  },
  methods: {
    ...mapActions({
      getTemplateCollectionsAction: 'createTemplate/getTemplateCollections',
      updateTemplateCollectionOrderAction: 'createTemplate/updateTemplateCollectionOrder',
      deleteTemplateCollectionAction: 'createTemplate/deleteTemplateCollection',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    selectMaterial(value) {
      this.$emit('update:selectedCollection', value);
    },
    toggleShow(value, material, isNew) {
      this.selectedMaterial = material;
      this.show = value;
      this.isNew = isNew;
    },
    onDelete(value) {
      this.deleteTemplateCollectionAction(value);
    },
    updateCollectionOrder(value) {
      this.updateTemplateCollectionOrderAction(value);
    },
  },
  computed: {
    ...mapState({
      materials: (state) => state.createTemplate.materials,
    }),
  },
  mounted() {
    this.getTemplateCollectionsAction();
  },
};
</script>

<template>
  <div :class="b('')">
    <div :class="b('header')">
      <h3 :class="b('title')">Frame Collections</h3>
      <a-button
        :class="b('new-collection-btn')"
        type="primary"
        @click.stop="toggleShow(true, {}, true)"
      >
        <template #icon><plus-outlined /></template>
        Create new collection
      </a-button>
    </div>

    <div :class="b('grid')">
      <div
        v-for="(material, index) in materials"
        :key="material.id"
        :class="b('card', { selected: material.id === selectedCollection.id })"
        :style="{ order: material.order }"
        tabindex="0"
        role="button"
        @click.stop="selectMaterial(material)"
        @keydown.enter="selectMaterial(material)"
      >
        <!-- Order buttons -->
        <div :class="b('order-controls')">
          <a-button
            v-if="index > 0"
            :class="b('order-btn')"
            type="text"
            size="small"
            @click.stop="updateCollectionOrder([
              { id: material.id, order: materials[index - 1].order },
              { id: materials[index - 1].id, order: material.order },
            ])"
          >
            <template #icon><left-outlined /></template>
          </a-button>
          <span :class="b('order-number')">#{{ index + 1 }}</span>
          <a-button
            v-if="index !== materials.length - 1"
            :class="b('order-btn')"
            type="text"
            size="small"
            @click.stop="updateCollectionOrder([
              { id: material.id, order: materials[index + 1].order },
              { id: materials[index + 1].id, order: material.order },
            ])"
          >
            <template #icon><right-outlined /></template>
          </a-button>
        </div>

        <!-- Image -->
        <div :class="b('card-image-wrap')">
          <img :class="b('card-image')" :src="material.imageUri" :alt="material.name" />
        </div>

        <!-- Content -->
        <div :class="b('card-content')">
          <span :class="b('card-title')">{{ material.name }}</span>
          <p v-if="material.description" :class="b('card-description')">
            {{ material.description }}
          </p>
          <p v-if="material.disclaimer" :class="b('card-disclaimer')">
            {{ material.disclaimer }}
          </p>
        </div>

        <!-- Actions -->
        <div :class="b('card-actions')">
          <a-button
            :class="b('action-btn')"
            type="text"
            size="small"
            @click.stop="toggleShow(true, material, false)"
          >
            <template #icon><edit-outlined /></template>
            Edit
          </a-button>
          <a-popconfirm
            title="Are you sure you want to delete this collection?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="onDelete(material.id)"
          >
            <a-button
              :class="b('action-btn', { danger: true })"
              type="text"
              danger
              size="small"
              @click.stop
            >
              <template #icon><delete-outlined /></template>
              Delete
            </a-button>
          </a-popconfirm>
        </div>
      </div>
    </div>

    <template v-if="show">
      <ArtCollection v-model:show="show" :collection="selectedMaterial" :is-new="isNew" />
    </template>
  </div>
</template>

<style scoped lang="scss" src="./frameTemplateCollections.scss"></style>
